import { combineReducers } from "redux";
import * as auth from "./reducers/auth/auth.js";
import * as categories from "./reducers/categories/categories.js";
import * as banners from "./reducers/banners/banners";
import * as setting from "./reducers/settings/settings";
import * as shopifyPricing from "./reducers/shopify-pricing/shopify-pricing.js";
import * as wixPricing from "./reducers/wix-pricing/wix-pricing.js";
import * as wocommercePricing from "./reducers/wocommerce-pricing/wocommerce-pricing.js";
import * as cartPricing from "./reducers/cart-pricing/cart-pricing.js";
import * as merchants from "./reducers/merchants/merchants";
import * as smtpDetails from "./reducers/smtp-details/smtpDetails"
import * as wixCategories from "./reducers/wix-categories/wixCategories";
import * as wocommerceCategories from "./reducers/wocommerce-categories/wocommerceCategories";
import * as activities from "./reducers/activities/activities";
import * as popupInfo from "./reducers/popup/popup";

 const appReducer = combineReducers({
  auth: auth.reducer,
  categories:categories.reducer,
  banners: banners.reducer,
  setting:setting.reducer,
  shopifyPricing:shopifyPricing.reducer,
  wixPricing:wixPricing.reducer,
  wocommercePricing:wocommercePricing.reducer,
  cartPricing:cartPricing.reducer,
  merchants: merchants.reducer,
  smtpDetails: smtpDetails.reducer,
  wixCategories: wixCategories.reducer,
  wocommerceCategories: wocommerceCategories.reducer,
  activities: activities.reducer,
  popupInfo: popupInfo.reducer,
});

export const rootReducer = (state, action) => {
  if (action.type === "LOG_OUT") {
    // for all keys defined in your persistConfig(s)
    localStorage.clear();
    // storage.removeItem('persist:otherKey')

    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
